import request from '@/utils/request'
import { v2Host } from '@/config/host'
// import _ from 'lodash'

/**
 * 获取任务列表接口
 * @param {*} params
 */
export function fetchJobList(params) {
  return request({
    url: `${v2Host}/dmaker/job/list`,
    method: 'get',
    params,
  })
}

/**
 * 取消打包任务
 * @param {*} params
 */
export function cancelJob(params) {
  return request({
    url: `${v2Host}/dmaker/job/cancel`,
    method: 'get',
    params,
  })
}
